// HeroSection.jsx
import React from "react";

const HeroSection = () => {
  return (
    <section className="hero-section" id="home">
      {/* Background Image */}
      <div className="hero-background"></div>
      
      {/* Content Container */}
      <div className="hero-container">
        {/* Left Content */}
        <div className="hero-content">
          {/* Badge */}
      

          {/* Main Heading */}
          <h1 className="hero-title animate-fade-in" style={{ animationDelay: '0.4s' }}>
            Stay Connected
            <span className="hero-gradient"> With FlyFi.</span>
          </h1>
          
          <p className="hero-description animate-fade-in" style={{ animationDelay: '0.6s' }}>
           Welcome to your all-in-one Telecom Wallet, designed to streamline your telecommunications management. Our platform allows you to easily manage your telecom services, track usage, and make payments, all in one place. Enjoy seamless integration and enhanced convenience, tailored to meet your needs.
          </p>

          {/* CTA Buttons */}
          <div className="hero-buttons animate-fade-in" style={{ animationDelay: '0.8s' }}>
            <button className="btn-primary" onClick={() => window.location.href = "https://flyfi.com.ng/api/get/app/device/download"}>
              Download The App
                <span class="btn-arrow">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 3v12"/>
                        <path d="M6 11l6 6 6-6"/>
                        <path d="M5 21h14"/>
                    </svg>
                </span>

            </button>
            <button className="btn-secondary" onClick={() => window.location.href = "https://uda.flyfi.com.ng/auth/login"}>
              <span class="play-icon">
                     <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <circle cx="12" cy="12" r="10"/>
                        <path d="M2 12h20"/>
                        <path d="M12 2c2.5 3 2.5 17 0 20"/>
                        <path d="M12 2c-2.5 3-2.5 17 0 20"/>
                    </svg>
               </span>
              Use Web version
            </button>
          </div>

          {/* Stats */}
          <div className="hero-stats">
            <div className="stat-item animate-fade-in" style={{ animationDelay: '1s' }}>
              <div className="stat-number">10K+</div>
              <div className="stat-label">Active Users</div>
            </div>
            <div className="stat-item animate-fade-in" style={{ animationDelay: '1.1s' }}>
              <div className="stat-number">4.9★</div>
              <div className="stat-label">Rating</div>
            </div>
            <div className="stat-item animate-fade-in" style={{ animationDelay: '1.2s' }}>
              <div className="stat-number">50+</div>
              <div className="stat-label">Countries</div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="hero-image-container animate-slide-in" style={{ animationDelay: '0.5s' }}>
          <div className="hero-glow"></div>
          <img 
            src="https://res.cloudinary.com/dbwpaspvh/image/upload/v1763223374/cloudphone_p2nbtp.png"
            alt="Hero Phone"
            className="hero-phone"
          />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="scroll-indicator animate-fade-in" style={{ animationDelay: '1.4s' }}>
        <div className="scroll-mouse">
          <div className="scroll-wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;